import RelationshipButton
  from 'Components/ComponentLibrary/Components/Uncategorized/RelationshipButton/RelationshipButton';

export default RelationshipButton;
